export default {
    methods: {
        formatOp(op) {
            const labels = {
                in: 'is',
                not_in: 'is not',
                any_of: 'any of',
                // "all of" reads as though the list itself must all exist; "every one of" can
                // only mean the person did each one, which is what it tests.
                all_of: 'every one of',
                is: 'is',
                is_not: 'is not',
                eq: 'is',
                neq: 'is not',
                is_between: 'is between',
                is_on: 'is on',
                is_before: 'is before',
                is_after: 'is after',
                within_last_days: 'in the last … days',
                more_than_days_ago: 'more than … days ago',
                within_next_days: 'in the next … days',
                more_than_days_ahead: 'more than … days ahead',
                is_blank: 'is blank',
                is_not_blank: 'is not blank',
                contains: 'contains',
                not_contains: 'does not contain',
                equals: 'equals',
                not_equals: 'does not equal',
                greater_than: 'greater than',
                gt: 'greater than',
                less_than: 'less than',
                lt: 'less than',
                between: 'between',
                gte: 'greater than or equal to',
                lte: 'less than or equal to',
            };

            return labels[op] || op;
        },
    },
};



// WEBPACK FOOTER //
// ./src/Assets/mixins/operatorLabels.js